var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('TianDiTuMap',{ref:"tianDiTuMapRef",attrs:{"center":_vm.computedMapCenter,"zoom":_vm.computedMapZoom,"companyMarkerImageSrc":_vm.companyMarkerImageSrc,"tipsText":_vm.displayTipsText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }